module.exports = __webpack_public_path__ + "media/images/favicon/android-icon-36x36-cd3abe9bd6505ca340b88b9fe6b3f364.png";